export default {
    Upgrade: 1,
    Complete: 2,
    CompletedAdditional: 3
};
